import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewChildren } from "@angular/core";
import { AssignationDropdownComponent } from "../assignation-dropdown/assignation-dropdown.component";
import { LogicalGrouperComponent } from "../logical-grouper/logical-grouper.component";

@Component({
    selector: "app-grouper-list",
    templateUrl: "./grouper-list.component.html",
    styleUrls: ["./grouper-list.component.scss"],
})
export class GrouperListComponent implements OnInit {
    @ViewChildren(LogicalGrouperComponent) logicalGroupers: LogicalGrouperComponent[];

    @ViewChild(AssignationDropdownComponent, {static: false}) assignationDropdown: AssignationDropdownComponent;

    @Input() items: any[] = [];
    @Input() dropdownItems: any[] = [];
    @Input() index: number;
    @Input() readonly = false;
    @Input() grouperOnly = false;

    @Output() select = new EventEmitter<any>();

    @Output() itemClicked = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit() {
    }

    addItemToList(data) {
        this.items.push(data);
        this.assignationDropdown.selectedItem = null;
    }

    onDelete(index: number) {
        if (this.readonly) {
            return;
        }
        this.items = this.items.filter((_, i) => i !== index);
    }

    onItemClicked(event: any) {
        this.itemClicked.emit(event);
    }

    getDropdownItems() {
        return this.dropdownItems.filter(dropdownItem => !this.items.find((item) => item.id === dropdownItem.id));
    }

    get selectedItems() {
        this.logicalGroupers.forEach((lg: any, i: number) => {
            if (this.items[i]) {
                this.items[i].selectedTasks = lg.selectedItems;
            }
        });
        return this.items;
    }

    onSelect(i: number) {
        this.select.emit({index: this.index, i: i});
    }
}
